TWENTY_YEARS_IN_SEC = 630720000
TUTORIAL_SHOWN_COOKIE_NAME = 'clo-cash-back-tutorial-shown'

window.CashBack ?= {}

CashBack.init = (payload, done) ->
  $ ->
    {cashBack, cookieDomain} = payload
    if cashBack?.showTutorialOnLoad
      #If there's a banner coming from the layout service, due to its lazy loaded image we don't know when the page will be ready
      #so wait a little bit launching the tutorial popup. If there is no banner, launch right away
      tooltipDelay = if $('#ls-in-app-messages:not(.hide)').length then cashBack?.tooltipDelay || 2000 else 0
      tutorialLauncher = =>
        CashBack.showTutorial cookieDomain

      setTimeout(tutorialLauncher, tooltipDelay)

    done()

CashBack.showTutorial = (cookieDomain) ->
  return if Cookie.get(TUTORIAL_SHOWN_COOKIE_NAME)
  cookieDomain ?= window.location.hostname

  $tooltip = $('#cash-back-tutorial-tooltip')
  return unless $tooltip.length

  onTooltipClose = ->
    Cookie.set TUTORIAL_SHOWN_COOKIE_NAME, 'true', TWENTY_YEARS_IN_SEC, cookieDomain
  $tooltip.one 'click', '.tooltip-close', onTooltipClose

  $trigger = $('.cash-back .tooltip-trigger')
  GIG.Tooltip.helpers.tooltip.apply $trigger, [{preventDefault: ->}]

module.exports = CashBack

